<header>
  <div class="header_wrapper">
    <a routerLink="/menu" *ngIf="showMenu" class="hamberger">
      <svg class="icon">
        <use xlink:href="#hamberger"></use>
      </svg>
    </a>
    <a class="close_menu" *ngIf="!showMenu" href="javascript:history.back()"></a>

    <a routerLink="/" *ngIf="showHome" class="home">
      <svg class="icon">
        <use xlink:href="#back"></use>
      </svg>
    </a>

    <a routerLink="/" class="logo-link">
      <img src="assets/img/logo.png" class="logo" />
    </a>

    <a routerLink="/find" class="search-icon"></a>

    <button *ngIf="showFav && story" (click)="onClickFav()" class="fav">
      <svg class="icon">
        <use xlink:href="#bookmark_off"></use>
      </svg>
    </button>
    <ul class="header_link">
      <div>
        <li><a routerLink="/about">初めての方へ</a></li>
        <li><a routerLink="/story/latest">新着記事</a></li>
        <li><a routerLink="/story/popular">人気記事</a></li>
        <li><a routerLink="/feat/list">連載一覧</a></li>
        <li><a routerLink="/company/list">掲載企業</a></li>
        <!-- <li><a routerLink="/find">見つける</a></li> -->
      </div>
      <!-- <li><a routerLink="/find"><svg class="icon"><use xlink:href="#search"></use></svg></a></li> -->
      <ng-container *ngIf="!anonymous; else guestuser">
        <li
          triggers="click"
          placement="bottom"
          tooltipClass="tipmenu"
          [autoClose]="'outside'"
          [ngbTooltip]="tipMenu"
          class="usericon"
        >
          <i></i>
        </li>
        <ng-template #tipMenu>
          <div class="user-displayname">{{ user.displayName }}&ensp;様</div>
          <a routerLink="/profile">プロフィール</a>
          <a routerLink="/favorite">お気に入り・フォロー</a>
          <a routerLink="/mypage">求人の管理</a>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLScMb02yW46RQ56nkrTg2z2l_7W_QHW0Nq3CXtUO0kJpSodykg/viewform"
            target="_blank"
          >
            お問い合わせ
          </a>
          <a (click)="signOut()">ログアウト</a>
        </ng-template>
      </ng-container>
      <ng-template #guestuser>
        <div class="sign-container">
          <li><a routerLink="/signup" class="signup-btn">新規登録</a></li>
          <li><a routerLink="/login">ログイン</a></li>
        </div>
      </ng-template>
    </ul>

    <a routerLink="/find" class="find">
      <svg class="icon">
        <use xlink:href="#search"></use>
      </svg>
    </a>
  </div>

  <invalid-profile-modal [isValidProfile]="showInvalidProfileModal"></invalid-profile-modal>
</header>
